"use client"

import { Search } from "lucide-react"
import { Button } from "@/shared/components/ui/button"
import { Input } from "@/shared/components/ui/input"
import { useState } from "react"
import { useNavigate } from "react-router-dom"

const SearchBar = () => {
  const [searchQuery, setSearchQuery] = useState("")
  const navigate = useNavigate()

  const handleBookNow = () => {
    window.open("https://m.me/travelwarehouseinc", "_blank", "noopener,noreferrer")
  }

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault()
    if (searchQuery.trim()) {
      // Navigate to destination page with search query
      navigate(`/destination?search=${encodeURIComponent(searchQuery.trim())}`)
    }
  }

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSearch(e)
    }
  }

  return (
    <div className="flex items-center gap-3 lg:gap-4">
      <form onSubmit={handleSearch} className="relative bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none" />
        <Input 
          type="text" 
          placeholder="Search destinations..." 
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onKeyPress={handleKeyPress}
          className="search-input pl-10 pr-10 w-48 lg:w-64 h-10 !bg-white !text-gray-900 placeholder:!text-gray-500 rounded-lg border-gray-200 focus:border-orange-500 focus:ring-orange-500 transition-colors" 
          style={{ 
            color: '#111827 !important', 
            backgroundColor: '#ffffff !important',
            caretColor: '#111827'
          }}
        />
        <button 
          type="submit" 
          className="absolute right-2 top-1/2 transform -translate-y-1/2 p-1 rounded hover:bg-gray-100 transition-colors"
          aria-label="Search"
        >
          <Search className="h-4 w-4 text-gray-400 hover:text-amber-600" />
        </button>
      </form>
      <Button 
        onClick={handleBookNow} 
        variant="ghost"
        className="btn-autumn-primary px-4 lg:px-6 h-10 rounded-lg transition-all shadow-md hover:shadow-lg hover:scale-105 font-semibold"
        style={{ background: 'linear-gradient(135deg, #f59e0b 0%, #ea580c 100%)', color: 'white' }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = 'linear-gradient(135deg, #ea580c 0%, #dc2626 100%)'
          e.currentTarget.style.color = 'white'
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = 'linear-gradient(135deg, #f59e0b 0%, #ea580c 100%)'
          e.currentTarget.style.color = 'white'
        }}
      >
        Book Now
      </Button>
    </div>
  )
}

export default SearchBar
